import request from 'axios';
import { getClientAuthHeader } from '../../client/token';
import { loadAction, getHostname } from './../helpers/utils';

export function casesUpdateColumnsAction(headers) {
    return {
        types: ['CASES_COLUMNS_SET_REQUEST', 'CASES_COLUMNS_SET_SUCCESS', 'CASES_COLUMNS_SET_FAILURE'],
        headers,
        promise: request.put('/api/v1/config/cases/headers', headers, getClientAuthHeader())
    };
}


// `paging` ({ page, pageSize, sort, desc }) loads a single page; without it the full list is loaded.
export function casesLoadAction(query, filter, archived, paging) {
    let searchRequest = loadAction('/api/v1/case/all', query, filter, archived);
    if (paging) {
        searchRequest += `${searchRequest.includes('?') ? '&' : '?'}page=${paging.page}&pageSize=${paging.pageSize}`;
        if (paging.append) {
            // Later pages do not need the tasks and stats again.
            searchRequest += '&more=true';
        }
        if (paging.sort) {
            searchRequest += `&sort=${encodeURIComponent(paging.sort)}&desc=${!!paging.desc}`;
        }
    }

    return {
        types: ['CASES_LOAD_REQUEST', 'CASES_LOAD_SUCCESS', 'CASES_LOAD_FAILURE'],
        append: !!(paging && paging.append),
        promise: request.get(searchRequest, getClientAuthHeader())
    };
}

export function casesPagingAction(paging) {
    return {
        type: 'CASES_PAGING',
        paging
    };
}

export function caseNewForClientAction(client) {
    return {
        type: 'CASE_NEW_FOR_CLIENT',
        client
    };
}

export function caseNewAction() {
    return {
        type: 'CASE_NEW'
    };
}

export function caseSetCurrentAction(matter) {
    return {
        type: 'CASE_SET_CURRENT',
        case: matter
    };
}

export function casesAllAction() {
    return {
        type: 'CASES_ALL'
    };
}

export function caseSavingNeededAction(savingNeeded) {
    return {
        type: 'CASE_SAVING_NEEDED',
        savingNeeded
    };
}

export function casesRefreshNeededAction(refreshNeeded) {
    return {
        type: 'CASES_REFRESH_NEEDED',
        refreshNeeded
    };
}

export function casesFilterAction(filter) {
    return {
        type: 'CASES_FILTER',
        filter
    };
}

export function caseDeleteAction(caseId, permanentlyDelete) {
    const types = ['CASE_DELETE_ID_REQUEST', 'CASE_DELETE_ID_SUCCESS', 'CASE_DELETE_ID_FAILURE'];
    if (!permanentlyDelete) {
        return {
            types,
            promise: request.delete('/api/v1/case/' + caseId, getClientAuthHeader())
        };
    }
       
    return {
        types,
        promise: request.delete('/api/v1/case/permanent/' + caseId, getClientAuthHeader())
    };
}

export function casesDeleteAction(caseIds, permanentlyDelete) {
    const types = ['CASES_DELETE_IDS_REQUEST', 'CASES_DELETE_IDS_SUCCESS', 'CASES_DELETE_IDS_FAILURE'];
    const data = {
        caseIds,
        permanentlyDelete
    };

    return {
        types,
        promise: request.post('/api/v1/cases/archive', data, getClientAuthHeader())
    };
}

export function casesSetStatesAction(caseIds, caseState) {
    const types = ['CASES_SET_CASE_STATES_REQUEST', 'CASES_SET_CASE_STATES_SUCCESS', 'CASES_SET_CASE_STATES_FAILURE'];
    const data = {
        caseIds,
        caseState
    };

    return {
        types,
        promise: request.post('/api/v1/cases/set_case_state', data, getClientAuthHeader())
    };
}

export function caseEditAction(editedCase, clear = false) {
    return {
        type: 'CASE_EDIT',
        current: editedCase,
        clear,
    };
}

export function caseClientSetAction(editedClient) {
    return {
        type: 'CASE_CLIENT_SET',
        currentClient: editedClient
    };
}

export function caseEditIdAction(id, initialCase = {}) {
    return {
        types: ['CASE_EDIT_ID_REQUEST', 'CASE_EDIT_ID_SUCCESS', 'CASE_EDIT_ID_FAILURE'],
        initialCase,
        promise: request.get('/api/v1/case/' + id, getClientAuthHeader())
    };
}

export function caseRefreshAction(id) {
    return {
        types: ['CASE_REFRESH_REQUEST', 'CASE_REFRESH_SUCCESS', 'CASE_REFRESH_FAILURE'],
        promise: request.get('/api/v1/case/' + id, getClientAuthHeader())
    };
}

export function templatesLoadAction() {
    return {
        types: ['TEMPLATES_LOAD_REQUEST', 'TEMPLATES_LOAD_SUCCESS', 'TEMPLATES_LOAD_FAILURE'],
        promise: request.get('/api/v1/uploads/template/all', getClientAuthHeader())
    };
}

export function templateAddAction(templateType, templateName, size) {
    return {
        type: 'TEMPLATE_ADD',
        templateType,
        templateName,
        size
    };
}

export function templateDeleteAction(templateType, templateName) {
    return {
        types: ['TEMPLATE_DELETE_REQUEST', 'TEMPLATE_DELETE_SUCCESS', 'TEMPLATE_DELETE_FAILURE'],
        promise: request.delete(`/api/v1/uploads/template/${templateType}/${encodeURIComponent(templateName)}`, getClientAuthHeader())
    };
}

export function templateVerifyAction(templateType, templateName) {
    return {
        types: ['TEMPLATE_VERIFY_REQUEST', 'TEMPLATE_VERIFY_SUCCESS', 'TEMPLATE_VERIFY_FAILURE'],
        promise: request.get(`/api/v1/verify/template/${templateType}/${encodeURIComponent(templateName)}`, getClientAuthHeader())
    };
}

export function caseFilesLoadAction(caseId) {
    return {
        types: ['CASE_FILES_LOAD_REQUEST', 'CASE_FILES_LOAD_SUCCESS', 'CASE_FILES_LOAD_FAILURE'],
        promise: request.get(`/api/v1/uploads/case/all/${caseId}`, getClientAuthHeader())
    };
}

export function templatesUploadToCaseFilesAction(templateType, templateName, finalName, caseId) {
    return {
        types: ['TEMPLATES_UPLOAD_TO_CASE_FILES_LOAD_REQUEST', 'TEMPLATES_UPLOAD_TO_CASE_FILES_LOAD_SUCCESS', 'TEMPLATES_UPLOAD_TO_CASE_FILES_LOAD_FAILURE'],
        promise: request.get(`/api/v1/upload/pdf_merged_template/${templateType}/${caseId}?name=${finalName}&f1=${templateName}`, getClientAuthHeader())
    };
}

export function caseFileAddAction(fileType, fileName, caseId, size = undefined) {
    return {
        type: 'CASE_FILE_ADD',
        fileType,
        fileName,
        caseId,
        size
    };
}

export function caseFileDeleteAction(fileType, fileName, caseId) {
    return {
        types: ['CASE_FILE_DELETE_REQUEST', 'CASE_FILE_DELETE_SUCCESS', 'CASE_FILE_DELETE_FAILURE'],
        promise: request.delete(`/api/v1/uploads/case/${caseId}/${fileType}/${encodeURIComponent(fileName)}`, getClientAuthHeader())
    };
}

export function sendFaxAction(data) {
    return {
        types: ['FAX_SEND_REQUEST', 'FAX_SEND_SUCCESS', 'FAX_SEND_FAILURE'],
        promise: request.post(`/api/v1/fax/send`, data, getClientAuthHeader())
    };
}

export function faxStatusAction(caseId) {
    return {
        types: ['FAX_STATUS_REQUEST', 'FAX_STATUS_SUCCESS', 'FAX_STATUS_FAILURE'],
        poll: `/api/v1/fax/status/${encodeURIComponent(caseId)}`
    };
}

export function caseSetServerError(error) {
    return {
        type: 'CASE_SET_SERVER_ERROR',
        error,
    };
}

export function caseSetServerSuccess(success) {
    return {
        type: 'CASE_SET_SERVER_SUCCESS',
        success,
    };
}

export function caseSubmitPublicAction(data, matterHash) {
    if (!data.intake) {
        data.intake = {};
    }

    // Expecting we are calling this from iframe
    const url = (window.location !== window.parent.location) ? document.referrer: document.location.href;
    if (!matterHash) {
        data.intake['PublicIntakeDate'] = 'server';
        data.intake['PublicIntakeSourceHost'] = getHostname(url);
        data.intake['PublicIntakeSourceFullUrl'] = url;
    }

    return {
        types: ['PUBLIC_CASE_SUBMIT_REQUEST', 'PUBLIC_CASE_SUBMIT_SUCCESS', 'PUBLIC_CASE_SUBMIT_FAILURE'],
        promise: request.put(`/api/v1/public_case/${encodeURIComponent(data['$IntakeHash$'])}/${encodeURIComponent(matterHash)}`, data)
    };
}

export function caseGetPublicData(intakeHash, matterHash) {
    return {
        types: ['PUBLIC_CASE_GET_REQUEST', 'PUBLIC_CASE_GET_SUCCESS', 'PUBLIC_CASE_GET_FAILURE'],
        promise: request.get(`/api/v1/public_case/${encodeURIComponent(intakeHash)}/${encodeURIComponent(matterHash)}`)
    };
}

export function casePublicIntakeFormEnable(caseId, enable) {
    return {
        types: [
            'CASE_PUBLIC_INTAKE_FORM_ALLOW_REQUEST', 'CASE_PUBLIC_INTAKE_FORM_ALLOW_SUCCESS', 'CASE_PUBLIC_INTAKE_FORM_ALLOW_FAILURE'
        ],
        promise: request.post('/api/v1/public_case', { type: 'public_case_access', caseId, enable }, getClientAuthHeader())
    };
}

export function caseIsPublicIntakeFormEnabled(caseId) {
    return {
        types: [
            'CASE_IS_PUBLIC_INTAKE_FORM_ENABLED_REQUEST', 'CASE_IS_PUBLIC_INTAKE_FORM_ENABLED_SUCCESS', 'CASE_IS_PUBLIC_INTAKE_FORM_ENABLED_FAILURE'
        ],
        promise: request.get(`/api/v1/case/public_case_hash/${encodeURIComponent(caseId)}`, getClientAuthHeader())
    };
}

export function caseSignSignaturePublicAction(signee, publicHash) {
    const data = {
        signee,
        publicHash
    };

    return {
        types: ['CASE_SIGN_REQUEST', 'CASE_SIGN_SUCCESS', 'CASE_SIGN_FAILURE'],
        promise: request.post('/api/v1/case/sign/signature', data),
    };
}

export function caseSignGetPdfPublicAction(publicHash) {
    return {
        types: ['CASE_SIGN_GET_PDF_REQUEST', 'CASE_SIGN_GET_PDF_SUCCESS', 'CASE_SIGN_GET_PDF_FAILURE'],
        promise: request.get('/api/v1/case/sign/pdf/' + encodeURIComponent(publicHash))
    };
}

export function caseSignDeclinePdfPublicAction(publicHash) {
    return {
        types: ['CASE_SIGN_DECLINE_PUBLIC_REQUEST', 'CASE_SIGN_DECLINE_PUBLIC_SUCCESS', 'CASE_SIGN_DECLINE_PUBLIC_FAILURE'],
        promise: request.get('/api/v1/case/sign/decline/' + encodeURIComponent(publicHash))
    };
}

export function caseGetPdfPublicAction(publicHash) {
    return {
        types: ['CASE_GET_PDF_PUBLIC_REQUEST', 'CASE_GET_PDF_PUBLIC_SUCCESS', 'CASE_GET_PDF_PUBLIC_FAILURE'],
        promise: request.get('/api/v1/case/pdf/public/' + encodeURIComponent(publicHash))
    };
}

export function caseGetPdfAction(caseId, folder, name) {
    return {
        types: ['CASE_GET_PDF_REQUEST', 'CASE_GET_PDF_SUCCESS', 'CASE_GET_PDF_FAILURE'],
        promise: request.get(`/api/v1/case/pdf/shared/${caseId}/${encodeURIComponent(folder)}/${encodeURIComponent(name)}`, getClientAuthHeader())
    };
}

export function caseHashDeleteAction(hash) {
    return {
        types: ['CASE_HASH_DELETE_REQUEST', 'CASE_HASH_DELETE_SUCCESS', 'CASE_HASH_DELETE_FAILURE'],
        promise: request.delete('/api/v1/hash/' + encodeURIComponent(hash), getClientAuthHeader())
    };
}

export function caseSignGeneratePdfAction(caseId, name, placeholders, signees) {
    const data = {
        signees,
        placeholders
    };

    return {
        types: ['CASE_SIGN_GENERATE_REQUEST', 'CASE_SIGN_GENERATE_SUCCESS', 'CASE_SIGN_GENERATE_FAILURE'],
        promise: request.post('/api/v1/case/sign/generate/' + encodeURIComponent(caseId) + '/' + encodeURIComponent(name), data, getClientAuthHeader())
    };
}

export function casePaymentGenerateAction(data) {
    const data_ = {
        caseId: data['caseId'],
        amount: data['chargeAmount'],
        description: data['description'],
        invoiceItems: data['invoiceItems'],
        account: data['account'],
        accountType: data['accountType']
    };

    return {
        types: ['CASE_PAYMENT_GENERATE_REQUEST', 'CASE_PAYMENT_GENERATE_SUCCESS', 'CASE_PAYMENT_GENERATE_FAILURE'],
        promise: request.post('/api/v1/case/pay/generate/', data_, getClientAuthHeader())
    };
}

export function caseGetPaymmentHashPublicAction(publicHash) {
    return {
        types: ['CASE_PAYMENT_HASH_PUBLIC_REQUEST', 'CASE_PAYMENT_HASH_PUBLIC_SUCCESS', 'CASE_PAYMENT_HASH_PUBLIC_FAILURE'],
        promise: request.get('/api/v1/case/pay/' + encodeURIComponent(publicHash), getClientAuthHeader())
    };
}

export function caseLawPayPayPublicAction(cardToken = undefined, caseId = undefined, amount = undefined, publicHash = undefined, description = undefined, lawPayAccount = undefined) {
    let data = {
        cardToken,
        amount,
        caseId,
        publicHash,
        description,
        account: lawPayAccount
    };

    return {
        types: ['CASE_LAWPAY_PAY_REQUEST', 'CASE_LAWPAY_PAY_SUCCESS', 'CASE_LAWPAY_PAY_FAILURE'],
        promise: request.post('/api/v1/case/lawpay/pay', data, getClientAuthHeader())
    };
}

export function casePayPalPayOrderCreateAction(amount, caseId, description = undefined, publicHash = undefined) {
    let data = {
        amount,
        caseId,
        description,
        publicHash
    };

    return {
        types: ['CASE_PAYPAL_ORDER_CREATE_REQUEST', 'CASE_PAYPAL_ORDER_CREATE_SUCCESS', 'CASE_PAYPAL_ORDER_CREATE_FAILURE'],
        promise: request.post('/api/v1/case/paypal/order/create', data, getClientAuthHeader())
    };
}

export function casePayPalOrderApproveAction(orderId, amount, description = undefined, caseId = undefined, publicHash = undefined) {
    let data = {
        amount,
        description,
        caseId,
        publicHash,
        orderId
    };

    return {
        types: ['CASE_PAYPAL_ORDER_APPROVE_REQUEST', 'CASE_PAYPAL_ORDER_APPROVE_SUCCESS', 'CASE_PAYPAL_ORDER_APPROVE_FAILURE'],
        promise: request.post('/api/v1/case/paypal/order/approve', data, getClientAuthHeader())
    };
}

export function caseGetChargesAction(caseId) {
    return {
        types: ['CASE_CHARGES_GET_REQUEST', 'CASE_CHARGES_GET_SUCCESS', 'CASE_CHARGES_GET_FAILURE'],
        promise: request.get('/api/v1/case/charges/' + encodeURIComponent(caseId), getClientAuthHeader())
    };
}

export function caseEmailsGetAction(caseId) {
    return {
        types: ['CASE_EMAILS_GET_REQUEST', 'CASE_EMAILS_GET_SUCCESS', 'CASE_EMAILS_GET_FAILURE'],
        promise: request.get('/api/v1/case/emails/' + encodeURIComponent(caseId), getClientAuthHeader())
    };
}

export function caseEmailAddAction(caseId, email) {
    return {
        type: 'CASE_EMAIL_ADD',
        caseId,
        email
    };
}

export function caseGetEvents(caseId) {
    return {
        types: ['CASE_EVENTS_LOAD_REQUEST', 'CASE_EVENTS_LOAD_SUCCESS', 'CASE_EVENTS_LOAD_FAILURE'],
        promise: request.get('/api/v1/events/' + encodeURIComponent(caseId), getClientAuthHeader())
    };
}

export function caseEditEvent(event) {
    delete event['$EventEditAction$'];
    return {
        types: ['CASE_EVENT_EDIT_REQUEST', 'CASE_EVENT_EDIT_SUCCESS', 'CASE_EVENT_EDIT_FAILURE'],
        promise: request.put('/api/v1/event/', event, getClientAuthHeader())
    };
}

export function caseDeleteEvent(eventId,  eventType, version = -1) {
    return {
        types: ['CASE_EVENT_DELETE_REQUEST', 'CASE_EVENT_DELETE_SUCCESS', 'CASE_EVENT_DELETE_FAILURE'],
        promise: request.delete('/api/v1/event/' + encodeURIComponent(eventId) + '/'  + encodeURIComponent(version) + '/' + encodeURIComponent(eventType), getClientAuthHeader())
    };
}

export function caseGetSmsEvents(caseId, phone) {
    const data = {
        caseId,
        phone,
    };

    return {
        types: ['CASE_SMS_GET_REQUEST', 'CASE_SMS_GET_SUCCESS', 'CASE_SMS_GET_FAILURE'],
        promise: request.post('/api/v1/user/sms/all/', data, getClientAuthHeader())
    };
}
